import { render, staticRenderFns } from "./exerciseinfoadd.vue?vue&type=template&id=f3b67058&scoped=true"
import script from "./exerciseinfoadd.vue?vue&type=script&lang=js"
export * from "./exerciseinfoadd.vue?vue&type=script&lang=js"
import style0 from "./exerciseinfoadd.vue?vue&type=style&index=0&id=f3b67058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b67058",
  null
  
)

export default component.exports